'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useState, useEffect } from 'react';
import DepositDetails from './deposit-details';
import { useTranslations } from 'next-intl';
import { getSafeInsets } from '@/utils/browser';
import IconFont from '@/components/ui/iconFont';
import IntelligentCustomerService from '../intelligent-customer-service';

interface RechargeDetailModalProps {
  order_id: string;
  type: 1 | 2; // 1: cash deposit, 2: digital currency deposit
}

const RechargeDetailModal = NiceModal.create<RechargeDetailModalProps>(({ order_id, type }) => {
  const modal = useModal();
  const t = useTranslations('personal');
  const [topSafe, setTopSafe] = useState(0);
  const getSafeInsetsData = async () => {
    const { topSafe } = await getSafeInsets();
    const topSafeCur = topSafe > 0 ? topSafe - 5 : 0;
    setTopSafe(topSafeCur || 0);
  };
  useEffect(() => {
    getSafeInsetsData();
  }, []);

  const handleClose = (e?: React.MouseEvent) => {
    // 阻止冒泡，不然会自动关闭上一层弹窗（具体原因尚不明确）
    e?.stopPropagation();
    modal.hide();
  };

  return (
    <Dialog.Root open={modal.visible} onOpenChange={(isOpen) => {
      if (!isOpen) {
        handleClose();
      }
    }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/80" />
        <Dialog.Content className="fixed inset-0 z-50 w-full h-full bg-dark flex flex-col">
          <VisuallyHidden>
            <Dialog.Title>{t('depositDetails')}</Dialog.Title>
          </VisuallyHidden>

          <div
            className="flex relative text-center py-[27px] px-7 flex-shrink-0 align-middle"
            style={{
              paddingTop: topSafe + 27,
            }}
          >
            <h1 className="text-base text-primary font-semibold absolute left-1/2 transform -translate-x-1/2">{t('depositDetails')}</h1>

            <div className="flex items-center ml-auto space-x-[32px]">
              <IntelligentCustomerService type={1} orderId={order_id} trackCurrentPage="Recharge Detail Page" />

              <button
                onClick={handleClose}
                className="flex items-center justify-center"
              >
                <IconFont name="close" size={13} color="#a9b5cb" />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-x-hidden overflow-y-auto px-[12px]">
            <DepositDetails order_id={order_id} type={type} />
            {/* 客服联系信息 */}
            {/* <ContactCustomerService type="1" orderId={order_id} className="fixed left-0 bottom-[30px] w-full flex flex-col items-center" /> */}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
});

export default RechargeDetailModal;
